import { render, staticRenderFns } from "./Behaviour.vue?vue&type=template&id=6f699330&scoped=true&"
import script from "./Behaviour.vue?vue&type=script&lang=js&"
export * from "./Behaviour.vue?vue&type=script&lang=js&"
import style0 from "./Behaviour.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Behaviour.vue?vue&type=style&index=1&id=6f699330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f699330",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRadio,VRadioGroup,VRow})
